'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _cloner = require('cloner');

var _traverse = require('traverse');

var _traverse2 = _interopRequireDefault(_traverse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateDecorator() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function deepBind(cls, name, desc) {
    if ((typeof cls === 'undefined' ? 'undefined' : (0, _typeof3.default)(cls)) === "object" && (typeof name === 'undefined' ? 'undefined' : (0, _typeof3.default)(name)) === "object" && ((typeof desc === 'undefined' ? 'undefined' : (0, _typeof3.default)(desc)) !== "object" || !desc.initializer)) {
      //isnt being used as a decorator! bind in object and context, then run initializer
      return generateDecorator({ obj: cls, context: name, opts: opts })().initializer();
    }

    if (desc && typeof desc.value === "function") {
      var bound = void 0;
      return {
        configurable: true,
        enumerable: desc.enumerable || true,
        get: function get() {
          if (bound) return bound;
          bound = desc.value.bind(this);
          return bound;
        }
      };
    }

    return {
      enumerable: true,
      writable: true,
      configurable: false,
      initializer: function initializer() {
        var context = opts.context || this;
        if (desc && typeof desc.value === "function") {
          debugger;
          cls;
          name;
          desc;
          self;
          return desc.value.bind(cls);
        }
        var src = opts.obj || desc.initializer.call(this);

        if ((typeof src === 'undefined' ? 'undefined' : (0, _typeof3.default)(src)) !== "object") throw new Error("must provide object to traverse");
        if ((typeof context === 'undefined' ? 'undefined' : (0, _typeof3.default)(context)) !== "object") throw new Error("must provide context to bind to");

        var clone = _cloner.deep.copy(src);
        (0, _traverse2.default)(clone).forEach(function (x) {
          var _this = this;

          var current = this;
          if (typeof x === "function" && opts.bindFunctions !== false) {
            this.update(x.bind(context), true);
          } else if (x && (typeof x === 'undefined' ? 'undefined' : (0, _typeof3.default)(x)) === "object") {
            var keys = (0, _keys2.default)(x);
            keys.forEach(function (key) {
              var descriptor = (0, _getOwnPropertyDescriptor2.default)(x, key);
              if (descriptor && (descriptor.set || descriptor.get)) {
                if (opts.bindProperties !== false) {
                  delete x[key];
                  (0, _defineProperty2.default)(x, key, (0, _assign2.default)(descriptor, {
                    get: descriptor.get && descriptor.get.bind(context),
                    set: descriptor.set && descriptor.set.bind(context),
                    enumerable: descriptor.hasOwnProperty("enumerable") ? descriptor.enumerable : true
                  }));
                }
                _this.keys.splice(_this.keys.indexOf(key), 1);
              }
            });
            this.update(x);
          }
        });

        return _cloner.deep.merge(src, clone);
      }
    };
  };
}

var deepBind = generateDecorator();
deepBind.onlyFunctions = generateDecorator({ bindProperties: false });
deepBind.onlyProperties = generateDecorator({ bindFunctions: false });

exports.default = deepBind;


//////////////////
// WEBPACK FOOTER
// ./~/deep-bind-decorator/dist/deep-bind-decorator.js
// module id = ./node_modules/deep-bind-decorator/dist/deep-bind-decorator.js
// module chunks = 0